import React from "react";
import { connect } from "react-redux";
import { Redirect, Route, Switch } from "react-router-dom";

import { STATUS_LOGGED } from "store/actions/auth";

import LoginEmployeePage from "views/login-employee";
import AttendanceManagement from "views/attendance-management";
import EmployeeTopbar from "components/template/employee-topbar";
import EmployeeMenu from "components/template/employee-menu";
import MainContent from "components/template/content";

import Dashboard from "./dashboard";
import Activities from "./activities";
import { EmployeeRoot } from "./theme";

/** Shell del portale dipendente: possiede login, layout e logout delle pagine /employee. */
function EmployeeArea({ loggedIn }) {
  if (!loggedIn) return <LoginEmployeePage />;

  return (
    <EmployeeRoot>
      <EmployeeTopbar />
      <EmployeeMenu />
      <MainContent>
        <Switch>
          <Route exact path="/employee-portal" component={Dashboard} />
          <Route exact path="/employee-portal/attendance" component={AttendanceManagement} />
          <Route exact path="/employee-portal/activities" component={Activities} />
          <Route exact path="/attendance-management" render={() => <Redirect to="/employee-portal/attendance" />} />
          <Redirect to="/employee-portal" />
        </Switch>
      </MainContent>
    </EmployeeRoot>
  );
}

export { EmployeeArea };

const mapStateToProps = (state) => {
  return {
    loggedIn: state.auth.employee?.status === STATUS_LOGGED,
  };
};

export default connect(mapStateToProps)(EmployeeArea);
